import { render } from "./TableBase.vue?vue&type=template&id=2fe6fcc0"
import script from "./TableBase.vue?vue&type=script&lang=ts"
export * from "./TableBase.vue?vue&type=script&lang=ts"
script.render = render

export default script